import axios from "axios";
import { Constants } from "../utils/Constants";

const BASE_URL = `${Constants.baseUrl}/dashboard`;

export const getStats = () => axios.get(`${BASE_URL}/stats`);

export const getTotalColaboradores = () => axios.get(`${BASE_URL}/total-colaboradores`);

export const getViagensEmAndamento = () => axios.get(`${BASE_URL}/viagens-em-andamento`);

export const getViagensRealizadasMes = () => axios.get(`${BASE_URL}/viagens-realizadas-mes`);

export const getUltimasViagens = () => axios.get(`${BASE_URL}/ultimas-viagens`);
